import Vue from "vue"
import apiClient from "@/utils/cb-client"

import { baseState, baseActions, baseMutations, baseGetters } from "@/store/common/base-config"
import { reorderFields } from "@/utils/helper-functions";

const state = {
  ...baseState,
  set_modal: false,
  data: {
    loaded: false
  },
  tos_holder: {}
}

const SET_CONFIG_DATA = "SET_CONFIG_DATA";
const SET_MODAl = "SET_MODAl";
const SET_TOS_HOLDER = "SET_TOS_HOLDER";
const SET_TOS_AGREED = "SET_TOS_AGREED";
const SET_PREFERRED_CURRENCY_CODE = "SET_PREFERRED_CURRENCY_CODE";

const actions = {
  ...baseActions,
  load_paynow_config({commit, state, dispatch}) {
    return new Promise((resolve, reject) => {
      if(!state.data.loaded) {
        try{
          var data = window.hpConfig;
          commit(SET_CONFIG_DATA, data.sections.reduce((o, section) => {
            section['fields'] = reorderFields(section.fields);
            o[section.type] = section;
            return o;
          }, {}));
          dispatch('set_base_config', data);
          commit(SET_TOS_HOLDER, data.tos_holder);
          resolve(true);
        }
        catch(error) {
          reject(error)
        };
      }
      else {
        resolve(true);
      }
    });
  },
  set_modal({commit, state, dispatch}, value) {
    commit(SET_MODAl, value);
  },
  set_tos_agreed({commit,state}, enabled) {
    commit(SET_TOS_AGREED, enabled);
  }
}

const mutations = {
  ...baseMutations,
  [SET_CONFIG_DATA] (state, sections) {
    Vue.set(state, 'sections', sections);
    state.data.loaded = true;
  },
  [SET_MODAl] (state, value) {
    state.set_modal = value;
  },
  [SET_TOS_HOLDER] (state, tosHolder) {
    Vue.set(state, 'tos_holder', tosHolder);
  },
  [SET_TOS_AGREED] (state, enabled) {
    Vue.set(state, "tos_agreed", enabled);
  }
}

const getters = {
  ...baseGetters,
  hosted_page_type: () => "paynow",
  paynow_config_loaded: state => state.data.loaded,
  set_modal : state => state.set_modal,
  translate: state => (key) => {
    return state.texts['paynow.' + key];
  },
  // translate static
  stranslate: state => (key) => {
    return state.texts['hp_v3.paynow.' + key];
  },
  tos_agreed: (state) => state.tos_agreed,
  tos_enabled: state => state.tos_holder && !!state.tos_holder.txt,
  tos_holder: state => state.tos_holder,
  autocomplete_enabled: (state, getters) => (pname) => state.sections[pname] && state.sections[pname].use_address_autocomplete,
  entry_point: state => state.entry_point,
  estimate_total: state => undefined,
  sections: state => state.sections,
}


export default {
  state,
  actions,
  mutations,
  getters
}